'use strict';

DoohApps
.directive('dropZone', ['DialogHandler', 'UploadFileStorage', function (DialogHandler, UploadFileStorage) {
    return {
        restrict: 'A',
        scope: {
            object: '=object',
            inputid: '@',
            limit: '=',
            maxSize: '@'
        },
        link: function (scope, element) {
            if (typeof scope.maxSize == 'undefined')
                scope.maxSize = 2147483648; //2GB
            element.on('dragover', function (event) {
                event.stopPropagation();
                event.preventDefault();
            });
            element.on('drop', function (event) {
                event.stopPropagation();
                event.preventDefault();
                if (scope.limit != undefined) {
                    if (scope.limit == 1) {
                        var tmpArray = [event.originalEvent.dataTransfer.files[0]];
                        UploadFileStorage.SetFiles(tmpArray, scope.maxSize);
                    }

                }
                else {
                    UploadFileStorage.SetFiles(event.originalEvent.dataTransfer.files, scope.maxSize);
                }

                if (scope.inputid == undefined) angular.element('#fileControl').trigger('change');
                else angular.element('#' + scope.inputid).trigger('change');
            })
        }
    }
}]);